import { Modal } from "react-bootstrap";
import "./GalleryPopUp.scss";
import { useState } from "react";
import { useUserContext } from "@/context/UserContext";
import { notShowAgainGallery } from "@/services/UserService";

interface GalleryPopUpPropsI {
  show: boolean;
  onHide: () => void;
}
const yodaPic = "../../assets/images/yoda-baby.jpg";
function GalleryPopUp(props: GalleryPopUpPropsI) {
  const { show, onHide } = props;

  const [notShow, setNotShow] = useState<boolean>(false);
  const { currentUser, userToken, fetchUserData } = useUserContext();

  const handleHide = async () => {
    if (currentUser && notShow) {
      await notShowAgainGallery(userToken).then((res) => {
        if (res && res.status === 200) {
          fetchUserData();
        }
      });
    } else if (!currentUser && notShow) {
      localStorage.setItem("notShowAgainGallery", "true");
    }
    onHide();
  };

  return (
    <Modal
      className="gallery-pop-up-modal"
      show={show}
      centered
      onHide={onHide}
    >
      <Modal.Body>
        <img src={yodaPic} alt="yoda" />
        <div className="text-container">
          <p>
            YOU DON'T NEED TO HAVE AN ACCOUNT TO REPORT MISTAKES. Just click on
            the photo and hit 'Report' underneath + input the reason.
          </p>
        </div>
        <div>
          <label htmlFor="notShowAgain" className="me-2 font-bold">
            Don't show again
          </label>
          <input
            id="notShowAgain"
            type="checkbox"
            className="m-0"
            checked={notShow}
            onChange={(e) => setNotShow(e.target.checked)}
          />
        </div>
        <button className="btn btn-primary" onClick={handleHide}>
          Ok
        </button>
      </Modal.Body>
    </Modal>
  );
}

export default GalleryPopUp;
